import React, { useRef, useState, useEffect } from "react";
import Certificate from "../../assets/images/Certificate4.jpeg";
import { getDatabase, ref, get, update } from "firebase/database";
import { app } from "../firebase";

const Certificate4 = () => {
  // Existing state variables
  const [studentName, setStudentName] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [originalSchoolName, setOriginalSchoolName] = useState("");
  const [principalVoice, setPrincipalVoice] = useState("");
  const [principalName, setPrincipalName] = useState("");
  const [originalPrincipalVoice, setOriginalPrincipalVoice] = useState("");
  const [originalPrincipalName, setOriginalPrincipalName] = useState("");
  const [certificateOf, setCertificateOf] = useState("");
  const [originalCertificateOf, setOriginalCertificateOf] = useState("");
  const [schoolLogo, setSchoolLogo] = useState('');

  const [congratulations, setCongratulations] = useState("");
  const [originalCongratulations, setOriginalCongratulations] = useState("");
  const [guest1, setGuest1] = useState("");
  const [originalGuest1, setOriginalGuest1] = useState("");
  const [guest2, setGuest2] = useState("");
  const [originalGuest2, setOriginalGuest2] = useState("");

  const [isEditing, setIsEditing] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const canvasRef = useRef(null);
  const certificateImageRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  const udiseNumber = localStorage.getItem("udiseNumber");


  useEffect(() => {
    let isMounted = true;
  
    const loadData = () => {
      try {
        setIsLoading(true);
        setFetchError(null);
  
        // Load school name from localStorage only
        const cachedName = localStorage.getItem('schoolName');
        if (cachedName) {
          setSchoolName(cachedName);
          setOriginalSchoolName(cachedName);
        } else {
          setSchoolName('');
          setOriginalSchoolName('');
          setFetchError("No school name available - please set one");
        }
  
        // Load all other local storage data
        loadLocalStorageData();
  
      } catch (error) {
        if (!isMounted) return;
        console.error("Error loading data:", error);
        setFetchError("Failed to load data");
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };
  
    const loadLocalStorageData = () => {
      // Principal details
      const savedPrincipalVoice = localStorage.getItem('principalVoice');
      const savedPrincipalName = localStorage.getItem('principalName');
      
      if (savedPrincipalVoice) {
        setPrincipalVoice(savedPrincipalVoice);
        setOriginalPrincipalVoice(savedPrincipalVoice);
      }
      
      if (savedPrincipalName) {
        setPrincipalName(savedPrincipalName);
        setOriginalPrincipalName(savedPrincipalName);
      }
  
      // Certificate of
      const savedCertificateOf = localStorage.getItem('certificateOf');
      if (savedCertificateOf) {
        setCertificateOf(savedCertificateOf);
        setOriginalCertificateOf(savedCertificateOf);
      }
  
      // New fields
      const savedCongratulations = localStorage.getItem('congratulations');
      if (savedCongratulations) {
        setCongratulations(savedCongratulations);
        setOriginalCongratulations(savedCongratulations);
      }
  
      const savedGuest1 = localStorage.getItem('guest1');
      if (savedGuest1) {
        setGuest1(savedGuest1);
        setOriginalGuest1(savedGuest1);
      }
  
      const savedGuest2 = localStorage.getItem('guest2');
      if (savedGuest2) {
        setGuest2(savedGuest2);
        setOriginalGuest2(savedGuest2);
      }
      
      const savedStudentName = localStorage.getItem('studentName'); // Add this line
      if (savedStudentName) {
        setStudentName(savedStudentName); // Set the student name state
      }
      const savedLogo = localStorage.getItem('schoolLogo');
      if (savedLogo) {
        setSchoolLogo(savedLogo);
      }
    };
  
    loadData();
  
    return () => {
      isMounted = false;
    };
  }, [udiseNumber]); // Removed db dependency since we're not using Firebase for school name
  
  
      const fetchSchoolData = async (udiseNumber) => {
        try {
          const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
    
          request.onsuccess = async (event) => {
            const db = event.target.result;
            const transaction = db.transaction(['schoolData'], 'readonly');
            const objectStore = transaction.objectStore('schoolData');
            const request = objectStore.get(udiseNumber);
    
            request.onsuccess = (event) => {
              const data = event.target.result;
              
              if (data) {
                setSchoolName(data.schoolName);
                // setSchoolLogo(data.schoolLogo); 
              }
            };
    
            request.onerror = (event) => {
              console.error("Error fetching school data:", event.target.error);
         
            };
          };
    
          request.onerror = (event) => {
            console.error("Error opening IndexedDB:", event.target.error);
          };
        } catch (error) {
          console.error("Error fetching school data:", error);
        }
      };
    
    useEffect(() => {
      fetchSchoolData (udiseNumber);
    }, [udiseNumber]);
  
  
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const base64 = event.target.result;
      setSchoolLogo(base64);
      localStorage.setItem('schoolLogo', base64); // Save logo persistently
    };
    reader.readAsDataURL(file);
  };
      
  useEffect(() => {
    if (schoolLogo) {
      drawCanvas();
    }
  }, [schoolLogo]);
  
    
  

  // Modified handleUpdate to only update localStorage, not Firebase
  const handleUpdate = async () => {
    try {
      setIsUpdating(true);
      
      localStorage.setItem('schoolName', schoolName);
      localStorage.setItem('principalVoice', principalVoice);
      localStorage.setItem('principalName', principalName);
      localStorage.setItem('certificateOf', certificateOf);
      localStorage.setItem('congratulations', congratulations);
      localStorage.setItem('guest1', guest1);
      localStorage.setItem('guest2', guest2);
      localStorage.setItem('studentName',studentName);
  
      // Update original values
      setOriginalSchoolName(schoolName);
      setOriginalPrincipalVoice(principalVoice);
      setOriginalPrincipalName(principalName);
      setOriginalCertificateOf(certificateOf);
      setOriginalCongratulations(congratulations);
      setOriginalGuest1(guest1);
      setOriginalGuest2(guest2);
  
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating data:", error.message);
      alert('Failed to update: ' + error.message);
    } finally {
      setIsUpdating(false);
    }
  };
  function drawCenteredText(ctx, text, y, xStart, xEnd, font = '20px Times New Roman') {
    ctx.font = font;
    ctx.textAlign = 'left'; // we'll manually handle alignment
    ctx.textBaseline = 'middle'; // centers vertically on Y
  
    const textWidth = ctx.measureText(text).width;
    const xCenter = (xStart + xEnd) / 2;
    const x = xCenter - textWidth / 2;
  

    ctx.fillText(text, x, y);
  }
  

 
  useEffect(() => {
    drawCanvas();
  }, [
    studentName,
    schoolName,
    principalVoice,
    principalName,
    certificateOf,
    congratulations,
    guest1,
    guest2,
  ]);

    const drawCanvas = ()=>{
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    canvas.width = 800;
    canvas.height = 1131;

    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      if (schoolLogo) {
        const logoImg = new Image();
        logoImg.onload = () => {
          ctx.drawImage(logoImg, 57, 65, 90, 90); // Draw the logo image at top left corner
        };
        logoImg.src = schoolLogo;
      }
      // Draw certificate of text
      if (certificateOf) {
        ctx.fillStyle = "#404654";
        ctx.font = 'bold 30px "Times New Roman", serif';
        ctx.textAlign = "center";
        ctx.fillText(certificateOf, canvas.width / 2, 320);
      }

  
     // Helper function to wrap text
function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
  const words = text.split(' ');
  let line = '';
  let lines = [];
  
  for (let n = 0; n < words.length; n++) {
    const testLine = line + words[n] + ' ';
    const metrics = ctx.measureText(testLine);
    const testWidth = metrics.width;
    if (testWidth > maxWidth && n > 0) {
      lines.push(line.trim());
      line = words[n] + ' ';
    } else {
      line = testLine;
    }
  }
  lines.push(line.trim());

  // Draw each line
  lines.forEach((lineText, index) => {
    ctx.fillText(lineText, x, y + index * lineHeight);
  });
}

// Draw school name with wrapping
if (schoolName) {
  ctx.fillStyle = "#000000";
  ctx.font = 'bold 30px "Lora", serif';
  ctx.textAlign = "center";
  const maxWidth = canvas.width - 190; // 20px padding on each side
  const lineHeight = 40;
  const x = (canvas.width / 2)+ 45;
  const y =100;
  wrapText(ctx, schoolName, x, y, maxWidth, lineHeight);
}

      // Draw student name
      if (studentName) {
        ctx.fillStyle = "#000000";
        ctx.font = 'italic 40px "Times New Roman", serif';
        ctx.textAlign = "center";
        ctx.fillText(`"${studentName}"`, canvas.width / 2, canvas.height / 2);
      }

      // Draw congratulations paragraph
      if (congratulations) {
        ctx.fillStyle = "#000000";
        ctx.font = '20px "Times New Roman", serif';
        ctx.textAlign = "center";
        wrapText(
          ctx,
          congratulations,
          canvas.width / 2,
          canvas.height / 2 + 100,
          600,
          30
        );
      }

      // Draw principal details
      if (principalVoice || principalName) {
        ctx.fillStyle = "#000000";


        if (principalVoice) {
          drawCenteredText(ctx, principalVoice, canvas.height - 201, 130, 279, 'bold 23px Times New Roman');
        }
        
        if (principalName) {
          drawCenteredText(ctx, principalName, canvas.height - 201, 505, 657, 'bold 23px Times New Roman');
        }
       

        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 1;

        if (principalVoice) {
          ctx.beginPath();
          ctx.moveTo(150, canvas.height - 140);
          ctx.stroke();
        }

        if (principalName) {
          ctx.beginPath();
          ctx.moveTo(canvas.width - 300, canvas.height - 140);
          ctx.stroke();
        }
      }

      // Draw guest names
      if (guest1 || guest2) {
        ctx.fillStyle = "#000000";
        ctx.font = 'bold 18px "Times New Roman", serif';

        
        // Draw guest1 (label1)
        if (guest1) {
          drawCenteredText(ctx, guest1, canvas.height - 167,  130, 279, 'bold 18px Times New Roman');
        }

        // Draw guest2 (label2)
        if (guest2) {
          drawCenteredText(ctx, guest2, canvas.height - 167, 505, 657, 'bold 18px Times New Roman');
        }
      }
    };

    img.src = Certificate;
    certificateImageRef.current = img;
  }


  const handleDeleteLogo = () => {
    setSchoolLogo('');
    localStorage.removeItem('schoolLogo'); // Clear saved logo
    drawCanvas();
  };

  const handleDownload = () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = "certificate.png";
    link.href = dataURL;
    link.click();
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setSchoolName(originalSchoolName);
    setPrincipalVoice(originalPrincipalVoice);
    setPrincipalName(originalPrincipalName);
    setCertificateOf(originalCertificateOf);
    setCongratulations(originalCongratulations);
    setGuest1(originalGuest1);
    setGuest2(originalGuest2);
    setIsEditing(false);
  };



  return (
  <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "15px",
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          marginBottom: "50px",
        }}
      >
        <h3 style={{ color: "#34495e", marginBottom: "30px" }}>
          प्रमाणपत्र जनरेटर
        </h3>
  
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            maxWidth: "500px",
          }}
        >
          <div style={{ width: "100%", position: "relative" }}>
            <label style={{ fontSize: "18px" }}>चे प्रमाणपत्र:</label>
            <input
              type="text"
              value={certificateOf}
              onChange={(e) => setCertificateOf(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="e.g., 'Certificate of Excellence'"
              disabled={!isEditing}
            />
          </div>
          <div style={{ width: '100%', position: 'relative' }}>
    <label style={{ fontSize: '18px' }}>Logo:</label>
    <img
      src={schoolLogo}
      alt="School Logo"
      style={{
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: '10px',
      }}
    />
     <button
              onClick={handleDeleteLogo}
              style={{
                padding: '5px 10px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Remove Logo
            </button>
    <input
      type="file"
      accept="image/*"
      onChange={(e) => handleLogoChange(e)}
      style={{
        padding: '7px',
        fontSize: '16px',
        width: '100%',
        borderRadius: '5px',
        border: '1px solid #ccc',
        marginBottom: '10px',
      }}
      placeholder="Add Logo"
      disabled={!isEditing}
    />
  </div>
  
  <div style={{ width: '100%', position: 'relative' }}>
    <label style={{ fontSize: '18px' }}>शाळेचे नाव:</label>
    <input
      type="text"
      value={schoolName}
      onChange={(e) => setSchoolName(e.target.value)}
      style={{
        padding: '7px',
        fontSize: '16px',
        width: '100%',
        borderRadius: '5px',
        border: '1px solid #ccc',
        marginBottom: '10px',
      }}
      placeholder="School Name"
      disabled={!isEditing}
    />
    {fetchError && (
      <div style={{
        padding: '7px',
        background: '#ffebee',
        color: '#c62828',
        borderRadius: '5px',
        marginBottom: '10px'
      }}>
        {fetchError}
      </div>
    )}
  </div>
  
          <div style={{ width: "100%" }}>
            <label style={{ fontSize: "18px" }}>विजेत्याचे नाव:</label>
            <input
              type="text"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="Winner's Name"
            />
          </div>
  
          <div style={{ width: "100%" }}>
            <label style={{ fontSize: "18px" }}>अभिनंदन परिच्छेद:</label>
            <textarea
              value={congratulations}
              onChange={(e) => setCongratulations(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
                minHeight: "100px",
                resize: "vertical",
              }}
              placeholder="Enter congratulation message..."
              disabled={!isEditing}
            />
          </div>
  
          <div style={{ width: "100%", position: "relative" }}>
            <label style={{ fontSize: "18px" }}>लेबल-1:</label>
            <input
              type="text"
              value={guest1}
              onChange={(e) => setGuest1(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="लेबल-1"
              disabled={!isEditing}
            />
          </div>
  
          <div style={{ width: "100%", position: "relative" }}>
            <label style={{ fontSize: "18px" }}>टेक्स्ट 1:</label>
            <input
              type="text"
              value={principalVoice}
              onChange={(e) => setPrincipalVoice(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="टेक्स्ट 1"
              disabled={!isEditing}
            />
          </div>
  
          <div style={{ width: "100%", position: "relative" }}>
            <label style={{ fontSize: "18px" }}>लेबल-2:</label>
            <input
              type="text"
              value={guest2}
              onChange={(e) => setGuest2(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="लेबल-2 "
              disabled={!isEditing}
            />
          </div>
  
          <div style={{ width: "100%", position: "relative" }}>
            <label style={{ fontSize: "18px" }}>टेक्स्ट 2:</label>
            <input
              type="text"
              value={principalName}
              onChange={(e) => setPrincipalName(e.target.value)}
              style={{
                padding: '7px',
                fontSize: "16px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
              placeholder="टेक्स्ट 2"
              disabled={!isEditing}
            />
          </div>
  
          {!isEditing ? (
            <button
              onClick={handleEdit}
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                alignSelf: "flex-start",
              }}
            >
              Edit Details
            </button>
          ) : (
            <div
              style={{ display: "flex", gap: "10px", alignSelf: "flex-start" }}
            >
              <button
                onClick={handleUpdate}
                disabled={isUpdating}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#2196F3",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {isUpdating ? "Updating..." : "Update"}
              </button>
              <button
                onClick={handleCancelEdit}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
  
        <div
          style={{
            border: "1px solid #ddd",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <canvas
            ref={canvasRef}
            style={{
              display: "block",
            }}
          />
        </div>
  
        <button
          onClick={handleDownload}
          disabled={!studentName || !schoolName || !principalName}
          style={{
            padding: "12px 25px",
            fontSize: "16px",
            backgroundColor:
              studentName && schoolName && principalName ? "#d4af37" : "#cccccc",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor:
              studentName && schoolName && principalName
                ? "pointer"
                : "not-allowed",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) =>
            studentName &&
            schoolName &&
            principalName &&
            (e.target.style.backgroundColor = "#b89735")
          }
          onMouseOut={(e) =>
            studentName &&
            schoolName &&
            principalName &&
            (e.target.style.backgroundColor = "#d4af37")
          }
        >
          Download Certificate
        </button>
      </div>
  );
};

export default Certificate4;
